import { render, staticRenderFns } from "./training-policy.vue?vue&type=template&id=08ab6184&scoped=true"
import script from "./training-policy.vue?vue&type=script&lang=js"
export * from "./training-policy.vue?vue&type=script&lang=js"
import style0 from "./training-policy.vue?vue&type=style&index=0&id=08ab6184&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ab6184",
  null
  
)

export default component.exports